(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDialogController', TabFleetsDialogController);

    TabFleetsDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabFleets', 'TabDomains', 'domain', 'TabFiles', 'Principal'];

    function TabFleetsDialogController($state, $timeout, $scope, entity, TabFleets, TabDomains, domain, TabFiles, Principal) {
        var vm = this;
        vm.tabFleets = entity;
        vm.domain = domain;

        Principal.identity().then(function (data) {
            if(data.authorities.indexOf('ROLE_TECH') > -1) {
                vm.domains = TabDomains.query({size: 1000});
                vm.tabfiles = TabFiles.query({size: 1000});
            }
        });



        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFleetsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-fleets');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFleets.id !== null) {
                if (vm.tabFleets.notVisibleUsers != null){
                    vm.tabFleets.users = vm.tabFleets.users.concat(vm.tabFleets.notVisibleUsers);
                }
                TabFleets.update(vm.tabFleets, onSaveSuccess, onSaveError);
            } else {
                TabFleets.save(vm.tabFleets, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-fleets');
        };

        vm.reloadUsers = function () {
            vm.tabFleets.users = [];
            vm.domain = TabDomains.get({id: vm.tabFleets.domains.id});
        };
    }
})();
